import { useState } from "react";
import { toast } from "sonner";
import { UserCircle, KeyRound } from "lucide-react";
import api, { errMsg } from "../lib/api";
import PageHeader from "../components/PageHeader";
import { useAuth } from "../context/AuthContext";

export default function Profile() {
  const { user } = useAuth();
  const [pwd, setPwd] = useState({ oldPassword: "", newPassword: "" });
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", pwd);
      toast.success("Password changed");
      setPwd({ oldPassword: "", newPassword: "" });
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div>
      <PageHeader title="Profile" subtitle="Your account" />
      <div className="p-6 lg:p-8 grid md:grid-cols-2 gap-6 max-w-4xl">
        <div className="card p-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="h-16 w-16 rounded-full bg-slate-900 text-white flex items-center justify-center text-2xl font-head font-bold">{user.name?.[0]?.toUpperCase()}</div>
            <div>
              <div className="font-head text-xl font-bold">{user.name}</div>
              <div className="text-sm text-slate-500">{user.email}</div>
              <span className="badge bg-amber-100 text-amber-700 mt-1 capitalize">{user.role}</span>
            </div>
          </div>
          <dl className="text-sm space-y-2 mt-4">
            <div className="flex justify-between border-b border-slate-100 py-2"><dt className="text-slate-500">Login ID</dt><dd className="font-mono">{user.loginId}</dd></div>
            <div className="flex justify-between border-b border-slate-100 py-2"><dt className="text-slate-500">Mobile</dt><dd>{user.mobile || "—"}</dd></div>
            <div className="flex justify-between py-2"><dt className="text-slate-500">Permissions</dt><dd>{user.role === "admin" ? "Full access" : (user.permissions || []).join(", ") || "OA only"}</dd></div>
          </dl>
        </div>
        <form onSubmit={change} className="card p-6" data-testid="change-password-form">
          <h3 className="font-head font-semibold flex items-center gap-2 mb-4"><KeyRound className="h-4 w-4 text-amber-600" /> Change Password</h3>
          <label className="label">Current Password</label>
          <input type="password" className="input mb-4" value={pwd.oldPassword} onChange={(e) => setPwd({ ...pwd, oldPassword: e.target.value })} required data-testid="old-password-input" />
          <label className="label">New Password</label>
          <input type="password" className="input mb-6" value={pwd.newPassword} onChange={(e) => setPwd({ ...pwd, newPassword: e.target.value })} required data-testid="new-password-input" />
          <button className="btn-primary w-full" disabled={busy} data-testid="change-password-btn">{busy ? "Saving…" : "Change Password"}</button>
        </form>
      </div>
    </div>
  );
}
